<!-- Header -->
<div
  class="container mobile header"
  style="padding-left: 0px; padding-right: 0px"
>
  <nav class="navbar navbar-expand-lg navbar-light rounded">
    <div class="container mobile">
      <!-- logo -->

      <img
        [src]="logo"
        style="max-height: 50px; margin-top: 2px; margin-bottom: 2px"
      />

      <!-- Sidebar Toggle Button -->
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target=".navbar-collapse"
        aria-label="Toggle navigation"
        [attr.aria-expanded]="isExpanded"
        (click)="toggle()"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>

    <div
      class="navbar-collapse collapse text-right"
      [ngClass]="{ show: isExpanded }"
    >
      <ul class="navbar-nav mr-auto">
        <li class="nav-item dropdown">
          <nb-select
            #PlanSelection
            [(ngModel)]="ThePlan"
            placeholder="Select A Plan..."
            (ngModelChange)="PlanChanged($event)"
            style="min-width: 300px"
          >
            <nb-option-group i18n="@@MealPlans" title="Meal Plans">
              <nb-option *ngFor="let plan of plans" [value]="plan">{{
                plan.name
              }}</nb-option>
            </nb-option-group>
            <nb-option-group i18n="@@WorkoutPlans" title="Workout Plans">
              <nb-option *ngFor="let plan of FitnessPlans" [value]="plan">{{
                plan.name
              }}</nb-option>
            </nb-option-group>
          </nb-select>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li>
          <a
            class="nav-link"
            routerLink="/PatientView/calendar/{{ NotificationToken }}"
            i18n="@@Profile"
            >Program & Calendar</a
          >
        </li>
        <li>
          <a
            class="nav-link"
            routerLink="/PatientView/food/{{ NotificationToken }}"
            i18n="@@Profile"
            >Food Diary</a
          >
        </li>
        <li>
          <a
            class="nav-link"
            routerLink="/PatientView/billing/{{ NotificationToken }}"
            i18n="@@Billing"
            >Billing</a
          >
        </li>
        <li>
          <a
            class="nav-link"
            routerLink="/PatientView/GeneralInfo/{{ NotificationToken }}"
            i18n="@@Profile"
            >Profile</a
          >
        </li>
        <li>
          <a
            class="nav-link"
            routerLink="/PatientView/PatientAssessment/{{ NotificationToken }}"
            >Weekly CheckIn</a
          >
        </li>
        <li>
          <a
            class="nav-link"
            routerLink="/PatientView/PatientGoals/{{ NotificationToken }}"
            i18n="@@Goals"
            >Goals</a
          >
        </li>
      </ul>
    </div>
  </nav>
</div>

<!-- Alert -->
<div class="planViewAdvert" id="planViewAdvert" style="display: none">
  <div style="margin: 20px">
    Start sending your clients Meal and Workout plans like this one today!<br /><span
      style="font-size: 10pt"
      >Save time, look professional.</span
    >
    <br />

    <a
      href="https://go.trainerfriend.com/free-account-claim"
      class="btn btn-success"
      style="margin-top: 5px"
    >
      SIGN UP FOR FREE
    </a>
  </div>
</div>

<!-- Body -->
<nb-layout
  windowMode
  style="background: #ffffff !important; background-color: #ffffff"
>
  <nb-layout-column
    style="
      padding: 1rem 1rem 0 !important;
      margin-bottom: 50px;
      background-color: white;
    "
  >
    <router-outlet></router-outlet>
    <div style="height: 30px"></div>
  </nb-layout-column>
</nb-layout>

<div class="chat-window" *ngIf="showChatWindow && threadSubject.value">
  <button
    nbButton
    ghost
    status="default"
    class="chat-close-btn"
    (click)="showChatWindow = false"
  >
    <nb-icon icon="close"></nb-icon>
  </button>
  <app-chat-window [threadSubject]="threadSubject"></app-chat-window>
</div>
<div class="chat-btn" (click)="toggleChatWindow()">
  <i class="fa {{ showChatWindow ? 'fa-times' : 'fa-comments' }}"></i>
  <ng-container *ngIf="unSeenMessages | async as unSeenCount">
    <nb-badge
      *ngIf="unSeenCount"
      [text]="unSeenCount"
      status="danger"
      possition="top end"
      class=""
    ></nb-badge>
  </ng-container>
</div>
